import React, { useCallback } from "react";
import PathwayTextInputGroup from "../../_UI/Components/Inputs/PathwayTextInputGroup";
import { PathwayFormGrid } from "../../_UI/StyledComponents/PathwayForm";
import styled from "styled-components";
import { Button } from "reactstrap";
import PathwaySelectInputGroup from "../../_UI/Components/Inputs/PathwaySelectInputGroup";
import { LoadingSpinnerButton } from "../../_UI/Components/PathwayButtons";
import { ErrorMessage } from "../../_UI/Components/Alerts/PathwayAlertMessages";
import stringUtils from "../../_services/string-utils";
import { useSelector } from "react-redux";

const TikTokAppstoreExistingUserLogin = (props) => {
    const appstoreSetup = useSelector((state) => state.appstoreSetup);

    const internalSubmit = useCallback(() => {
        if (
            props.loginSubmitted &&
            !appstoreSetup.existingUserLoginLoading &&
            appstoreSetup.existingUserAvailableOrgs
        ) {
            console.log("call submitSelectedOrganizationAndClient");
            props.submitSelectedOrganizationAndClient();
        } else {
            console.log("call submitExistingUserInitialLogin");
            props.submitExistingUserInitialLogin();
        }
    }, [props, appstoreSetup.existingUserLoginLoading, appstoreSetup.existingUserAvailableOrgs]);
    return (
        <UserGrid>
            {props.loginSubmitted &&
            !appstoreSetup.existingUserLoginLoading &&
            appstoreSetup.existingUserAvailableOrgs ? (
                <>
                    <SelectRow>
                        <PathwaySelectInputGroup
                            label="Bitte wähle das Konto aus, mit dem Du den neuen Shop verbinden möchtest."
                            name={"selectedOrganizationExternalUUID"}
                            handleChange={props.handleSelectOrgAndClientChange}
                            value={props.existingUser.selectedOrganizationExternalUUID}
                        >
                            <option value="">Bitte wählen Sie</option>
                            <option value="createNewOrganization">Neuen Account erstellen</option>
                            {appstoreSetup.existingUserAvailableOrgs &&
                                appstoreSetup.existingUserAvailableOrgs.map((org) => (
                                    <option key={org.externalUUID} value={org.externalUUID}>
                                        {org.name}
                                    </option>
                                ))}
                        </PathwaySelectInputGroup>
                        {props.existingUser.selectedOrganizationExternalUUID === "createNewOrganization" && (
                            <PathwayTextInputGroup
                                label={"Name des Unternehmens"}
                                name={"organizationName"}
                                handleChange={props.handleSelectOrgAndClientChange}
                                value={props.existingUser.organizationName}
                                dataCy="organization-name-registration-input"
                            />
                        )}
                    </SelectRow>
                </>
            ) : (
                <PathwayFormGrid>
                    <PathwayTextInputGroup
                        type="mail"
                        name="email"
                        placeHolder="E-Mail"
                        dataCy="tiktok-mail-login-input"
                        handleChange={props.handleExistingUserLoginChange}
                        value={props.existingUser.email}
                        mandatory
                        autoFocus
                    />
                    <PathwayTextInputGroup
                        label={"Passwort"}
                        name={"password"}
                        type="password"
                        dataCy="tiktok-password-login-input"
                        handleChange={props.handleExistingUserLoginChange}
                        value={props.existingUser.password}
                        mandatory
                    />
                </PathwayFormGrid>
            )}

            <LoginRow>
                <ErrorMessage
                    messages={stringUtils.combineStrings(
                        appstoreSetup.existingUserLoginError,
                        appstoreSetup.shopifyNewUserError,
                        "\n"
                    )}
                />

                <LoadingSpinnerButton
                    className="btn btn-block btn-primary"
                    onClick={internalSubmit}
                    loading={appstoreSetup.existingUserLoginLoading}
                    disabled={
                        !props.existingUser.password ||
                        !props.existingUser.email ||
                        (props.loginSubmitted &&
                            !appstoreSetup.existingUserLoginLoading &&
                            appstoreSetup.existingUserAvailableOrgs &&
                            props.existingUser.selectedOrganizationExternalUUID === "")
                    }
                    buttonCyData="tiktok-login-button"
                >
                    Login
                </LoadingSpinnerButton>
            </LoginRow>
            <PasswordRow>
                <div />
                <Button color="link" className="px-0" onClick={props.toggleForgetPasswordModal}>
                    Passwort vergessen?
                </Button>
            </PasswordRow>
        </UserGrid>
    );
};

export default TikTokAppstoreExistingUserLogin;

const LoginRow = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    margin-top: 1rem;
`;

const SelectRow = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    row-gap: var(--gap-m);
`;

const PasswordRow = styled.div`
    display: grid;
    grid-template-columns: 0.6fr 0.4fr;
    align-items: center;
`;

const UserGrid = styled.div`
    display: grid;
`;
